import type { WDropDownMenuTranslations } from "./pl";

export const en: WDropDownMenuTranslations = {
  ariaLabelFallback: "Menu",
  empty: "No menu items.",
  seeAll: "see all",
  submenuExpand: "Expand",
  submenuCollapse: "Collapse",
  submenuToggleLabel: (name, open) =>
    `${open ? "Collapse" : "Expand"} submenu: ${name}`,
  devBanner: {
    prefix: "DEV-only:",
    body:
      "sample tree with 5-level nesting. Visible only in dev environment — admin bar toggle (icon",
    iconLabel: "list-bullets",
    suffix: ") disables this entry injection.",
    mockL1Name: "DEV: Full tree",
  },
};
